module.exports = __webpack_public_path__ + "static/img/logo_za.6bbb1ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_za.png
// module id = 252
// module chunks = 1